import { mergeStyleSets } from "@fluentui/react";
import { Divider } from "@fluentui/react-components";
import Select from "react-select";
import { CommonHelper } from "../../../utils/common/CommonHelper";
import {
  CHART_TYPE_DROPDOWN_OPTIONS,
  TIME_DURATION_DROPDOWN_OPTIONS,
  TIME_TYPE_DROPDOWN_OPTIONS,
} from "../../../utils/common/Constants";
import { AmdButton } from "../../common/form-controls/uncontrolled/Button/AmdButton";
import { AmdButtonType } from "../../common/form-controls/uncontrolled/Button/AmdButtonType";
import CapacityChangePopup from "./CapacityChangePopup";

function FlightDemandCapacitySubHeader({
  selectedButton,
  airport,
  timeRef,
  setTimeRef,
  refresh,
  setRefresh,
}: any) {
  const customStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: "10px",
      borderRadius: "20px",
      fontSize: "14px",
      fontWeight: "500",
    }),
  };
  const handleTimeTypeChange = (selectedOption: any) => {
    setTimeRef(selectedOption.value);
  };
  return (
    <>
      <header className="d-flex amd-container-hspacebtwn pa-sm-1 ai-center pt-sm-2">
        <div
          style={{
            display: "flex",
            paddingLeft: "50px",
            fontSize: "16px",
            fontWeight: "500",
          }}
        >
          {selectedButton}
        </div>
        <div className="d-flex ai-center">
          <Select
            options={TIME_TYPE_DROPDOWN_OPTIONS}
            value={TIME_TYPE_DROPDOWN_OPTIONS.find((o) => o.value === timeRef)}
            onChange={(selectedOption: any) => setTimeRef(selectedOption.value)}
            styles={customStyles}
            isSearchable={false}
          />
          <Divider className="px-sm-1" vertical appearance="strong" />
          <Select
            options={TIME_DURATION_DROPDOWN_OPTIONS}
            defaultValue={TIME_DURATION_DROPDOWN_OPTIONS[0]}
            styles={customStyles}
            isSearchable={false}
          />
          <Divider className="px-sm-1" vertical appearance="strong" />
          <CapacityChangePopup
            runway={selectedButton}
            airportCode={airport}
            refresh={refresh}
            setRefresh={setRefresh}
          />
        </div>
      </header>
    </>
  );
}
function FlightDemandCapacityHeaderMain({
  selectedButton,
  handleButtonClick,
  resourceData,
}: any) {
  const onChartTypeOptionDropDownChange = (_chartType: any) => {};

  const customStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: "10px",
      borderRadius: "20px",
      fontSize: "14px",
      fontWeight: "500",
    }),
  };

  return (
    <>
      <header className="amd-container-hspacebtwn pa-sm-3 ai-center pt-sm-4">
        {
          <div className="d-flex">
            <span className="fs-20 fw-500 pr-sm-5 as-center"></span>
            <Select
              options={CHART_TYPE_DROPDOWN_OPTIONS}
              defaultValue={CHART_TYPE_DROPDOWN_OPTIONS[0]}
              onChange={(selectedOption: any) => {
                onChartTypeOptionDropDownChange(selectedOption?.key);
              }}
              styles={customStyles}
              isSearchable={false}
            />
            <Divider className="px-sm-1" vertical appearance="strong" />
            <div
              style={{ display: "flex", overflowX: "auto" }}
              data-testid="flight-pill"
            >
              {resourceData?.map((button: any) => {
                return (
                  <AmdButton
                    className={`${
                      getPillButtonStyle(selectedButton, button).selected
                    } pillButton`}
                    text={button}
                    type={AmdButtonType.PILL}
                    key={CommonHelper.getGuid()}
                    onClick={() => {
                      if (
                        selectedButton.length > 1 ||
                        !selectedButton.includes(button)
                      ) {
                        handleButtonClick(button);
                      }
                    }}
                  />
                );
              })}
            </div>
          </div>
        }
      </header>
    </>
  );
}
const getPillButtonStyle = (
  selectedButtons: string[],
  buttonName: string
): any => {
  if (selectedButtons.includes(buttonName)) {
    return mergeStyleSets({
      selected: {
        backgroundColor: "rgb(12, 102, 225) !important", // Black background for selected buttons
        color: "#FFFFFF !important", // White text for selected buttons
      },
    });
  }

  return mergeStyleSets({
    selected: {
      backgroundColor: "#FFFFFF !important", // White background for unselected buttons
      color: "rgb(12, 102, 225) !important", // Black text for unselected buttons
    },
  });
};
export { FlightDemandCapacityHeaderMain, FlightDemandCapacitySubHeader };
